var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 115,
    viewBox: "0 0 132 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint0_linear_1_156)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint1_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 10.425C38.397 10.425 40.7378 8.09121 40.7378 5.21245C40.7378 2.33368 38.397 0 35.5095 0C32.6219 0 30.2811 2.33368 30.2811 5.21245C30.2811 8.09121 32.6219 10.425 35.5095 10.425Z",
    fill: "url(#paint2_linear_1_156)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 10.425C38.397 10.425 40.7378 8.09121 40.7378 5.21245C40.7378 2.33368 38.397 0 35.5095 0C32.6219 0 30.2811 2.33368 30.2811 5.21245C30.2811 8.09121 32.6219 10.425 35.5095 10.425Z",
    fill: "url(#paint3_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 12,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 10.425C68.6781 10.425 71.0189 8.09121 71.0189 5.21245C71.0189 2.33368 68.6781 0 65.7905 0C62.903 0 60.5621 2.33368 60.5621 5.21245C60.5621 8.09121 62.903 10.425 65.7905 10.425Z",
    fill: "url(#paint4_linear_1_156)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 10.425C68.6781 10.425 71.0189 8.09121 71.0189 5.21245C71.0189 2.33368 68.6781 0 65.7905 0C62.903 0 60.5621 2.33368 60.5621 5.21245C60.5621 8.09121 62.903 10.425 65.7905 10.425Z",
    fill: "url(#paint5_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 0,
    width: 12,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 10.425C98.9592 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9592 0 96.0716 0C93.184 0 90.8432 2.33368 90.8432 5.21245C90.8432 8.09121 93.184 10.425 96.0716 10.425Z",
    fill: "url(#paint6_linear_1_156)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 10.425C98.9592 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9592 0 96.0716 0C93.184 0 90.8432 2.33368 90.8432 5.21245C90.8432 8.09121 93.184 10.425 96.0716 10.425Z",
    fill: "url(#paint7_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 0,
    width: 11,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.353 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.353 10.425Z",
    fill: "url(#paint8_linear_1_156)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.353 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.353 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.353 10.425Z",
    fill: "url(#paint9_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 11,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3834C10.4568 28.5046 8.11594 26.171 5.22838 26.171C2.34082 26.171 0 28.5046 0 31.3834C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint10_linear_1_156)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3834C10.4568 28.5046 8.11594 26.171 5.22838 26.171C2.34082 26.171 0 28.5046 0 31.3834C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint11_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 26,
    width: 11,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 36.5958C38.397 36.5958 40.7378 34.2621 40.7378 31.3834C40.7378 28.5046 38.397 26.171 35.5095 26.171C32.6219 26.171 30.2811 28.5046 30.2811 31.3834C30.2811 34.2621 32.6219 36.5958 35.5095 36.5958Z",
    fill: "url(#paint12_linear_1_156)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 36.5958C38.397 36.5958 40.7378 34.2621 40.7378 31.3834C40.7378 28.5046 38.397 26.171 35.5095 26.171C32.6219 26.171 30.2811 28.5046 30.2811 31.3834C30.2811 34.2621 32.6219 36.5958 35.5095 36.5958Z",
    fill: "url(#paint13_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 26,
    width: 12,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 36.5958C68.6781 36.5958 71.0189 34.2621 71.0189 31.3834C71.0189 28.5046 68.6781 26.171 65.7905 26.171C62.903 26.171 60.5621 28.5046 60.5621 31.3834C60.5621 34.2621 62.903 36.5958 65.7905 36.5958Z",
    fill: "url(#paint14_linear_1_156)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 36.5958C68.6781 36.5958 71.0189 34.2621 71.0189 31.3834C71.0189 28.5046 68.6781 26.171 65.7905 26.171C62.903 26.171 60.5621 28.5046 60.5621 31.3834C60.5621 34.2621 62.903 36.5958 65.7905 36.5958Z",
    fill: "url(#paint15_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 26,
    width: 12,
    height: 11
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 36.5958C98.9592 36.5958 101.3 34.2621 101.3 31.3834C101.3 28.5046 98.9592 26.171 96.0716 26.171C93.184 26.171 90.8432 28.5046 90.8432 31.3834C90.8432 34.2621 93.184 36.5958 96.0716 36.5958Z",
    fill: "url(#paint16_linear_1_156)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 36.5958C98.9592 36.5958 101.3 34.2621 101.3 31.3834C101.3 28.5046 98.9592 26.171 96.0716 26.171C93.184 26.171 90.8432 28.5046 90.8432 31.3834C90.8432 34.2621 93.184 36.5958 96.0716 36.5958Z",
    fill: "url(#paint17_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 26,
    width: 11,
    height: 11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3834C131.581 28.5046 129.24 26.171 126.353 26.171C123.465 26.171 121.124 28.5046 121.124 31.3834C121.124 34.2621 123.465 36.5958 126.353 36.5958Z",
    fill: "url(#paint18_linear_1_156)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.353 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3834C131.581 28.5046 129.24 26.171 126.353 26.171C123.465 26.171 121.124 28.5046 121.124 31.3834C121.124 34.2621 123.465 36.5958 126.353 36.5958Z",
    fill: "url(#paint19_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 52,
    width: 11,
    height: 11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 62.7125C8.11594 62.7125 10.4568 60.3788 10.4568 57.5C10.4568 54.6212 8.11594 52.2875 5.22838 52.2875C2.34082 52.2875 0 54.6212 0 57.5C0 60.3788 2.34082 62.7125 5.22838 62.7125Z",
    fill: "url(#paint20_linear_1_156)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 62.7125C8.11594 62.7125 10.4568 60.3788 10.4568 57.5C10.4568 54.6212 8.11594 52.2875 5.22838 52.2875C2.34082 52.2875 0 54.6212 0 57.5C0 60.3788 2.34082 62.7125 5.22838 62.7125Z",
    fill: "url(#paint21_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 52,
    width: 11,
    height: 11
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 62.7125C38.397 62.7125 40.7378 60.3788 40.7378 57.5C40.7378 54.6212 38.397 52.2875 35.5095 52.2875C32.6219 52.2875 30.2811 54.6212 30.2811 57.5C30.2811 60.3788 32.6219 62.7125 35.5095 62.7125Z",
    fill: "url(#paint22_linear_1_156)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 62.7125C38.397 62.7125 40.7378 60.3788 40.7378 57.5C40.7378 54.6212 38.397 52.2875 35.5095 52.2875C32.6219 52.2875 30.2811 54.6212 30.2811 57.5C30.2811 60.3788 32.6219 62.7125 35.5095 62.7125Z",
    fill: "url(#paint23_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 52,
    width: 12,
    height: 11
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 62.7125C68.6781 62.7125 71.0189 60.3788 71.0189 57.5C71.0189 54.6212 68.6781 52.2875 65.7905 52.2875C62.903 52.2875 60.5621 54.6212 60.5621 57.5C60.5621 60.3788 62.903 62.7125 65.7905 62.7125Z",
    fill: "url(#paint24_linear_1_156)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 62.7125C68.6781 62.7125 71.0189 60.3788 71.0189 57.5C71.0189 54.6212 68.6781 52.2875 65.7905 52.2875C62.903 52.2875 60.5621 54.6212 60.5621 57.5C60.5621 60.3788 62.903 62.7125 65.7905 62.7125Z",
    fill: "url(#paint25_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 52,
    width: 12,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 62.7125C98.9592 62.7125 101.3 60.3788 101.3 57.5C101.3 54.6212 98.9592 52.2875 96.0716 52.2875C93.184 52.2875 90.8432 54.6212 90.8432 57.5C90.8432 60.3788 93.184 62.7125 96.0716 62.7125Z",
    fill: "url(#paint26_linear_1_156)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 62.7125C98.9592 62.7125 101.3 60.3788 101.3 57.5C101.3 54.6212 98.9592 52.2875 96.0716 52.2875C93.184 52.2875 90.8432 54.6212 90.8432 57.5C90.8432 60.3788 93.184 62.7125 96.0716 62.7125Z",
    fill: "url(#paint27_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 52,
    width: 11,
    height: 11
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 62.7125C129.24 62.7125 131.581 60.3788 131.581 57.5C131.581 54.6212 129.24 52.2875 126.353 52.2875C123.465 52.2875 121.124 54.6212 121.124 57.5C121.124 60.3788 123.465 62.7125 126.353 62.7125Z",
    fill: "url(#paint28_linear_1_156)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.353 62.7125C129.24 62.7125 131.581 60.3788 131.581 57.5C131.581 54.6212 129.24 52.2875 126.353 52.2875C123.465 52.2875 121.124 54.6212 121.124 57.5C121.124 60.3788 123.465 62.7125 126.353 62.7125Z",
    fill: "url(#paint29_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 78,
    width: 11,
    height: 11
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 88.8834C8.11594 88.8834 10.4568 86.5496 10.4568 83.6709C10.4568 80.7921 8.11594 78.4584 5.22838 78.4584C2.34082 78.4584 0 80.7921 0 83.6709C0 86.5496 2.34082 88.8834 5.22838 88.8834Z",
    fill: "url(#paint30_linear_1_156)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 88.8834C8.11594 88.8834 10.4568 86.5496 10.4568 83.6709C10.4568 80.7921 8.11594 78.4584 5.22838 78.4584C2.34082 78.4584 0 80.7921 0 83.6709C0 86.5496 2.34082 88.8834 5.22838 88.8834Z",
    fill: "url(#paint31_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 78,
    width: 11,
    height: 11
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 88.8834C38.397 88.8834 40.7378 86.5496 40.7378 83.6709C40.7378 80.7921 38.397 78.4584 35.5095 78.4584C32.6219 78.4584 30.2811 80.7921 30.2811 83.6709C30.2811 86.5496 32.6219 88.8834 35.5095 88.8834Z",
    fill: "url(#paint32_linear_1_156)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 88.8834C38.397 88.8834 40.7378 86.5496 40.7378 83.6709C40.7378 80.7921 38.397 78.4584 35.5095 78.4584C32.6219 78.4584 30.2811 80.7921 30.2811 83.6709C30.2811 86.5496 32.6219 88.8834 35.5095 88.8834Z",
    fill: "url(#paint33_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 78,
    width: 12,
    height: 11
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 88.8834C68.6781 88.8834 71.0189 86.5496 71.0189 83.6709C71.0189 80.7921 68.6781 78.4584 65.7905 78.4584C62.903 78.4584 60.5621 80.7921 60.5621 83.6709C60.5621 86.5496 62.903 88.8834 65.7905 88.8834Z",
    fill: "url(#paint34_linear_1_156)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 88.8834C68.6781 88.8834 71.0189 86.5496 71.0189 83.6709C71.0189 80.7921 68.6781 78.4584 65.7905 78.4584C62.903 78.4584 60.5621 80.7921 60.5621 83.6709C60.5621 86.5496 62.903 88.8834 65.7905 88.8834Z",
    fill: "url(#paint35_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 78,
    width: 12,
    height: 11
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 88.8834C98.9592 88.8834 101.3 86.5496 101.3 83.6709C101.3 80.7921 98.9592 78.4584 96.0716 78.4584C93.184 78.4584 90.8432 80.7921 90.8432 83.6709C90.8432 86.5496 93.184 88.8834 96.0716 88.8834Z",
    fill: "url(#paint36_linear_1_156)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 88.8834C98.9592 88.8834 101.3 86.5496 101.3 83.6709C101.3 80.7921 98.9592 78.4584 96.0716 78.4584C93.184 78.4584 90.8432 80.7921 90.8432 83.6709C90.8432 86.5496 93.184 88.8834 96.0716 88.8834Z",
    fill: "url(#paint37_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 78,
    width: 11,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 88.8834C129.24 88.8834 131.581 86.5496 131.581 83.6709C131.581 80.7921 129.24 78.4584 126.353 78.4584C123.465 78.4584 121.124 80.7921 121.124 83.6709C121.124 86.5496 123.465 88.8834 126.353 88.8834Z",
    fill: "url(#paint38_linear_1_156)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.353 88.8834C129.24 88.8834 131.581 86.5496 131.581 83.6709C131.581 80.7921 129.24 78.4584 126.353 78.4584C123.465 78.4584 121.124 80.7921 121.124 83.6709C121.124 86.5496 123.465 88.8834 126.353 88.8834Z",
    fill: "url(#paint39_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 104,
    width: 11,
    height: 11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.788C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.788C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint40_linear_1_156)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.788C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.788C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint41_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 104,
    width: 11,
    height: 11
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 115C38.397 115 40.7378 112.666 40.7378 109.788C40.7378 106.909 38.397 104.575 35.5095 104.575C32.6219 104.575 30.2811 106.909 30.2811 109.788C30.2811 112.666 32.6219 115 35.5095 115Z",
    fill: "url(#paint42_linear_1_156)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 115C38.397 115 40.7378 112.666 40.7378 109.788C40.7378 106.909 38.397 104.575 35.5095 104.575C32.6219 104.575 30.2811 106.909 30.2811 109.788C30.2811 112.666 32.6219 115 35.5095 115Z",
    fill: "url(#paint43_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 104,
    width: 12,
    height: 11
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 115C68.6781 115 71.0189 112.666 71.0189 109.788C71.0189 106.909 68.6781 104.575 65.7905 104.575C62.903 104.575 60.5621 106.909 60.5621 109.788C60.5621 112.666 62.903 115 65.7905 115Z",
    fill: "url(#paint44_linear_1_156)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7905 115C68.6781 115 71.0189 112.666 71.0189 109.788C71.0189 106.909 68.6781 104.575 65.7905 104.575C62.903 104.575 60.5621 106.909 60.5621 109.788C60.5621 112.666 62.903 115 65.7905 115Z",
    fill: "url(#paint45_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 104,
    width: 12,
    height: 11
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 115C98.9592 115 101.3 112.666 101.3 109.788C101.3 106.909 98.9592 104.575 96.0716 104.575C93.184 104.575 90.8432 106.909 90.8432 109.788C90.8432 112.666 93.184 115 96.0716 115Z",
    fill: "url(#paint46_linear_1_156)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0716 115C98.9592 115 101.3 112.666 101.3 109.788C101.3 106.909 98.9592 104.575 96.0716 104.575C93.184 104.575 90.8432 106.909 90.8432 109.788C90.8432 112.666 93.184 115 96.0716 115Z",
    fill: "url(#paint47_linear_1_156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 104,
    width: 11,
    height: 11
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 115C129.24 115 131.581 112.666 131.581 109.788C131.581 106.909 129.24 104.575 126.353 104.575C123.465 104.575 121.124 106.909 121.124 109.788C121.124 112.666 123.465 115 126.353 115Z",
    fill: "url(#paint48_linear_1_156)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.353 115C129.24 115 131.581 112.666 131.581 109.788C131.581 106.909 129.24 104.575 126.353 104.575C123.465 104.575 121.124 106.909 121.124 109.788C121.124 112.666 123.465 115 126.353 115Z",
    fill: "url(#paint49_linear_1_156)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_156",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_156",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_156",
    x1: 85.2771,
    y1: 131.134,
    x2: 13.8755,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_156",
    x1: 85.2771,
    y1: 131.134,
    x2: 13.8755,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_156",
    x1: 115.558,
    y1: 131.134,
    x2: 44.1566,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_156",
    x1: 115.558,
    y1: 131.134,
    x2: 44.1566,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_156",
    x1: 145.839,
    y1: 131.134,
    x2: 74.4376,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_156",
    x1: 145.839,
    y1: 131.134,
    x2: 74.4376,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_156",
    x1: 176.12,
    y1: 131.134,
    x2: 104.719,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_156",
    x1: 176.12,
    y1: 131.134,
    x2: 104.719,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_156",
    x1: 54.996,
    y1: 157.303,
    x2: -16.4045,
    y2: -24.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_156",
    x1: 54.996,
    y1: 157.303,
    x2: -16.4045,
    y2: -24.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_156",
    x1: 85.2771,
    y1: 157.303,
    x2: 13.8767,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_156",
    x1: 85.2771,
    y1: 157.303,
    x2: 13.8767,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_156",
    x1: 115.558,
    y1: 157.303,
    x2: 44.1578,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_156",
    x1: 115.558,
    y1: 157.303,
    x2: 44.1578,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_156",
    x1: 145.839,
    y1: 157.303,
    x2: 74.4389,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_156",
    x1: 145.839,
    y1: 157.303,
    x2: 74.4389,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_156",
    x1: 176.12,
    y1: 157.303,
    x2: 104.72,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_156",
    x1: 176.12,
    y1: 157.303,
    x2: 104.72,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_156",
    x1: 54.996,
    y1: 183.421,
    x2: -16.4057,
    y2: 1.61755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_156",
    x1: 54.996,
    y1: 183.421,
    x2: -16.4057,
    y2: 1.61755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_156",
    x1: 85.2771,
    y1: 183.421,
    x2: 13.8755,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_156",
    x1: 85.2771,
    y1: 183.421,
    x2: 13.8755,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_156",
    x1: 115.558,
    y1: 183.421,
    x2: 44.1566,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_156",
    x1: 115.558,
    y1: 183.421,
    x2: 44.1566,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_156",
    x1: 145.839,
    y1: 183.421,
    x2: 74.4376,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_156",
    x1: 145.839,
    y1: 183.421,
    x2: 74.4376,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_156",
    x1: 176.12,
    y1: 183.421,
    x2: 104.719,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_156",
    x1: 176.12,
    y1: 183.421,
    x2: 104.719,
    y2: 1.61749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_156",
    x1: 54.996,
    y1: 209.592,
    x2: -16.4057,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_156",
    x1: 54.996,
    y1: 209.592,
    x2: -16.4057,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_156",
    x1: 85.2771,
    y1: 209.592,
    x2: 13.8755,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_156",
    x1: 85.2771,
    y1: 209.592,
    x2: 13.8755,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_156",
    x1: 115.558,
    y1: 209.592,
    x2: 44.1566,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_156",
    x1: 115.558,
    y1: 209.592,
    x2: 44.1566,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_156",
    x1: 145.839,
    y1: 209.592,
    x2: 74.4376,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_156",
    x1: 145.839,
    y1: 209.592,
    x2: 74.4376,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_156",
    x1: 176.12,
    y1: 209.592,
    x2: 104.719,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_156",
    x1: 176.12,
    y1: 209.592,
    x2: 104.719,
    y2: 27.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_156",
    x1: 54.996,
    y1: 235.709,
    x2: -16.4057,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_156",
    x1: 54.996,
    y1: 235.709,
    x2: -16.4057,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_156",
    x1: 85.2771,
    y1: 235.709,
    x2: 13.8755,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_156",
    x1: 85.2771,
    y1: 235.709,
    x2: 13.8755,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_156",
    x1: 115.558,
    y1: 235.709,
    x2: 44.1566,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_156",
    x1: 115.558,
    y1: 235.709,
    x2: 44.1566,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_156",
    x1: 145.839,
    y1: 235.709,
    x2: 74.4376,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_156",
    x1: 145.839,
    y1: 235.709,
    x2: 74.4376,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_156",
    x1: 176.12,
    y1: 235.709,
    x2: 104.719,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_156",
    x1: 176.12,
    y1: 235.709,
    x2: 104.719,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.f2bd84f1122169d4662bd1a1dff07321.svg";
export { ForwardRef as ReactComponent };